import { render, staticRenderFns } from "./Carousels.vue?vue&type=template&id=2a97974f&"
import script from "./Carousels.vue?vue&type=script&lang=js&"
export * from "./Carousels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\yuichi\\git\\open_coupon\\public\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a97974f')) {
      api.createRecord('2a97974f', component.options)
    } else {
      api.reload('2a97974f', component.options)
    }
    module.hot.accept("./Carousels.vue?vue&type=template&id=2a97974f&", function () {
      api.rerender('2a97974f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/base/Carousels.vue"
export default component.exports